const Container = ({ className = '', children }) => {
  return (
    <div className={`container mx-auto px-4 py-2 ${className || ''}`}>
      {children}
    </div>
  );
};

export default Container;
